<div class="pagination" *ngIf="hidePagination">
  <div class="float-buttons">
      <button mat-stroked-button (click)="loadMore()" *ngIf="hideLoadMore">
       <mat-icon>expand_more</mat-icon> ver mais
      </button>
      <button mat-stroked-button (click)="loadLess()" *ngIf="hideLoadLess">
        <mat-icon>expand_less</mat-icon> ver menos
      </button>
  </div>  
</div>
